export const COLORS = ["#4f46e5", "#059669", "#ea580c", "#9333ea", "#0ea5e9", "#e11d48", "#64748b", "#d97706"];
export const HEAT_TINT = (v, max) => max === 0 ? "rgba(79,70,229,0)" : `rgba(79,70,229,${0.05 + 0.85 * (v / max)})`;
